import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import Header from '../components/Header';
import ProductCard from '../components/ProductCard';
import { Heart } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function WishlistPage() {
  const { user } = useAuth();
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/wishlist`)
      .then(r => setListings(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-[#FCFAF8]">
      <Header />
      <main className="max-w-6xl mx-auto px-4 sm:px-6 py-8">
        <div className="mb-8">
          <h1 className="font-heading text-3xl sm:text-4xl text-[#2C2A29]" data-testid="wishlist-title">My Wishlist</h1>
          <p className="font-body text-[#78716C] mt-1">Items you've saved for later</p>
        </div>

        {loading ? (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-5">
            {[1,2,3,4].map(i => (
              <div key={i} className="animate-pulse bg-cream-100 rounded-2xl h-64" />
            ))}
          </div>
        ) : listings.length === 0 ? (
          <div className="text-center py-20 bg-white rounded-3xl border border-cream-100/50" data-testid="wishlist-empty">
            <Heart size={48} className="mx-auto text-cream-200 mb-4" />
            <h3 className="font-heading text-xl text-[#2C2A29] mb-2">Your wishlist is empty</h3>
            <p className="font-body text-[#78716C] mb-6">Tap the heart on any product to save it here</p>
            <Link to="/" className="bg-[#F4C2C2] text-[#2C2A29] rounded-full px-6 py-3 font-body font-semibold transition-all hover:bg-[#ECAEAE]" data-testid="wishlist-browse">
              Browse Products
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-5" data-testid="wishlist-grid">
            {listings.map(listing => (
              <ProductCard key={listing.listing_id} listing={listing} currentUser={user} onWishlistChange={(id) => {
                setListings(prev => prev.filter(l => l.listing_id !== id));
              }} />
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
